var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollarA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 309,
    viewBox: "0 0 248 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Collar",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.0542 170.44C83.6105 169.605 79.3873 170.27 77.9404 171.18C77.9404 189.529 96.8125 201.793 123.23 201.793C149.648 201.793 168.309 189.732 168.309 171.383C166.786 169.874 161.859 169.728 160.15 170.333C159.019 185.107 145.133 193.032 123.534 193.032C101.988 193.032 88.2343 185.144 87.0542 170.44Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollarA);
export default __webpack_public_path__ + "static/media/Collar A.13acce28f9c2e81e9f26a290bb6118e1.svg";
export { ForwardRef as ReactComponent };